module.exports = __webpack_public_path__ + "img/goupiao_active.1b51b45c.png";